
// import React, { useState } from 'react';
// import {
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Tooltip,
//   IconButton,
//   useMediaQuery,
//   useTheme,
//   Box,
// } from '@mui/material';

// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
// import HistoryIcon from '@mui/icons-material/History';
// import MenuIcon from '@mui/icons-material/Menu';

// import './dashboardSideBar.css';

// const DashboardSidebar = ({ onPlaceOrder, onReport, onHistory }) => {
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const open = isMobile; // Mobile shows full drawer, desktop always collapsed

//   const toggleMobileDrawer = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const menuItems = [
//     { icon: <ShoppingCartIcon />, label: 'Order', onClick: onPlaceOrder },
//     { icon: <DescriptionOutlinedIcon />, label: 'Ledger Statement', onClick: onReport },
//     { icon: <HistoryIcon />, label: 'History', onClick: onHistory },
//   ];

//   const renderDrawerContent = () => (
//     <List>
//       {menuItems.map((item, index) => (
//         <Tooltip
//           title={!open ? item.label : ''}
//           placement="right"
//           key={index}
//           disableHoverListener={open}
//         >
//           <ListItemButton onClick={item.onClick}>
//             <ListItemIcon className="drawer-icon">{item.icon}</ListItemIcon>
//             {open && <ListItemText primary={item.label} className="list-item-text visible" />}
//           </ListItemButton>
//         </Tooltip>
//       ))}
//     </List>
//   );

//   return (
//     <>
//       {isMobile && (
//         <Box className="sidebar-toggle-button">
//           <IconButton onClick={toggleMobileDrawer} sx={{ color: '#fff' }}>
//             <MenuIcon />
//           </IconButton>
//         </Box>
//       )}
//       {isMobile ? (
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={toggleMobileDrawer}
//           ModalProps={{ keepMounted: true }}
//           classes={{ paper: 'mobile-drawer-paper' }}
//           sx={{
//             '& .MuiDrawer-paper': {
//               top: '50px',                // inline override for top only
//               height: 'calc(100vh - 50px)', // inline override for height only
//             },
//           }}
//         >
//           {renderDrawerContent()}
//         </Drawer>
//       ) : (
//         // Desktop Permanent Collapsed Drawer
//         <Drawer
//           variant="permanent"
//           className="custom-drawer collapsed"
//           classes={{ paper: 'drawer-paper collapsed' }}
//           sx={{
//             '& .MuiDrawer-paper': {
//               top: '50px',                // inline override for top only
//               height: 'calc(100vh - 50px)', // inline override for height only
//             },
//           }}
//         >
//           {renderDrawerContent()}
//         </Drawer>
//       )}
//     </>
//   );
// };

// export default DashboardSidebar;

import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { menuItems } from '../dashboardUtilts';
import './dashboardSideBar.css';

const drawerWidth = 240;
const collapsedWidth = 72;
const topOffset = 50;

const DashboardSidebar = ({ onPlaceOrder, onReport, onHistory,onshowAd }) => {
  // const DashboardSidebar = ({ onPlaceOrder, onReport, onHistory,onshowAd }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleMobileDrawer = () => setMobileOpen(prev => !prev);
  const sidemenuItems = menuItems({ onPlaceOrder, onReport, onHistory,onshowAd });
  const showLabels = isMobile ? mobileOpen : false;
  const handleItemClick = (index, onClick) => {
    setActiveIndex(index);
    onClick();
    if (isMobile) setMobileOpen(false);
  };

  const DrawerContent = () => (
    <List className="sidebar-list">
      {sidemenuItems.map((item, index) => {
        const isActive = index === activeIndex;

        return (
          <Tooltip
            key={item.label}
            title={!showLabels ? item.label : ''}
            placement="right"
            disableHoverListener={showLabels}
          >
            <ListItemButton
              onClick={() => handleItemClick(index, item.onClick)}
              className={`sidebar-item ${isActive ? 'active' : ''}`}
            >
              <ListItemIcon
                className={`sidebar-icon ${isActive ? 'active-icon' : ''} ${
                  showLabels ? 'with-label' : 'no-label'
                }`}
              >
                {item.icon}
              </ListItemIcon>
              {showLabels && <ListItemText primary={item.label} />}
            </ListItemButton>
          </Tooltip>
        );
      })}
    </List>
  );

  const drawerClassName = `drawer-paper ${showLabels ? 'expanded' : 'collapsed'}`;

  return (
    <>
      {isMobile && (
        <Box className="sidebar-toggle-button">
          <IconButton onClick={toggleMobileDrawer} aria-label="Open Sidebar">
            <MenuIcon sx={{ color: 'black' }}/>
          </IconButton>
        </Box>
      )}

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={isMobile ? toggleMobileDrawer : undefined}
        ModalProps={{ keepMounted: true }}
        classes={{ paper: drawerClassName }}
      >
        <DrawerContent />
      </Drawer>
    </>
  );
};

export default DashboardSidebar;

